import { Box } from "@compass/core";
import { ReactNode } from "react";

interface MicrosoftSssoButtonProps {
    onClick: () => void;
}

export const MicrosoftSssoButton = ({ onClick }: MicrosoftSssoButtonProps) => (
    <button
        onClick={onClick}
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#2F2F2F', // Dark theme standard
            color: '#FFFFFF',
            padding: '0 12px',
            height: '41px',
            border: 'none',
            borderRadius: '0px', // Microsoft uses sharp corners for branding
            cursor: 'pointer',
            fontSize: '15px',
            fontWeight: '600',
            fontFamily: '"Segoe UI", "Helvetica Neue", sans-serif',
        }}
    >
        {/* Official Microsoft Square Logo */}
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" style={{ marginRight: '12px' }}>
            <path fill="#f25022" d="M1 1h9v9H1z" />
            <path fill="#7fbb00" d="M11 1h9v9h-9z" />
            <path fill="#00a1f1" d="M1 11h9v9H1z" />
            <path fill="#ffbb00" d="M11 11h9v9h-9z" />
        </svg>
        Sign in with Microsoft
    </button>
);